import React, { FC } from 'react'
import './MentalEvaluation.scss'

interface propsType{
    register: any;
    errors:any;
    handleChange:(value:any)=>void
}

const MentalEvaluation:FC<propsType> = ({ register, errors, handleChange }) => {
  return (
        <div className="mentalEvaluation">
            <div className="card shadow-0 border-0">
            <div className="card-header bg-warning">
                <h6 className="text-dark fw-bolder">Physical &amp; Mental Evaluation</h6>
            </div>
            <div className="card-body shadow-0 border-0 row">
                <div className="form-group col-md-4">
                    <label >Height <span className="text-danger">*</span></label>
                  <input type="number" step="0.01" {...register('height', { required: 'Height is cannot be empty' })} onChange={handleChange} className="form-control"/>
                  {errors.height && <span className="text-danger">{errors.height.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Teeth <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('teeth', { required: 'select one option' })} onChange={handleChange}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.teeth && <span className="text-danger">{errors.teeth.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Chest <span className="text-danger">*</span></label>
                    <input type="number" className="form-control" {...register('chest', { required: 'select one option' })} onChange={handleChange}/>
                  {errors.chest && <span className="text-danger">{errors.chest.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Impediment <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('impediment', { required: 'select one option' })}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.impediment && <span className="text-danger">{errors.impediment.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Obesity <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('obese', { required: 'select one option' })} onChange={handleChange}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.obese && <span className="text-danger">{errors.obese.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Tattoos <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('tattoo', { required: 'select one option' })} onChange={handleChange}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.tattoo && <span className="text-danger">{errors.tattoo.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Are the knees bend? <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('bknees', { required: 'select one option' })} onChange={handleChange}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.bknees && <span className="text-danger">{errors.bknees.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Any Deformity? <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('deformed', { required: 'select one option' })} onChange={handleChange}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.deformed && <span className="text-danger">{errors.deformed.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Bow leg? <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('bow', { required: 'select one option' })} onChange={handleChange}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.bow && <span className="text-danger">{errors.bow.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Flat feet <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('flatfeet', { required: 'select one option' })} onChange={handleChange}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.flatfeet && <span className="text-danger">{errors.flatfeet.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Amputation <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('amputation', { required: 'select one option' })} onChange={handleChange}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.amputation && <span className="text-danger">{errors.amputation.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Knock knees <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('knockknees', { required: 'select one option' })} onChange={handleChange}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.knockknees && <span className="text-danger">{errors.knockknees.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >Expression <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('expression', { required: 'select one option' })} onChange={handleChange}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.expression && <span className="text-danger">{errors.expression.message}</span>}
                </div>
                <div className="form-group col-md-4">
                    <label >General knowledge <span className="text-danger">*</span></label>
                    <select className="form-control" {...register('knowledge', { required: 'select one option' })} onChange={handleChange}>
                        <option value="">--select option--</option>
                        <option value="1">PASS</option>
                        <option value="0">FAIL</option>
                    </select>
                  {errors.knowledge && <span className="text-danger">{errors.knowledge.message}</span>}
                </div>
                <div className="form-group col-md-6">
                    <label >Recommended/Not-Recommended <span className="text-danger">*</span></label>
                    <select {...register('recommendation', { required: 'select one option' })} onChange={handleChange} className="form-control">
                        <option value="">--select option--</option>
                        <option value="0">Not Recommended</option>
                        <option value="1">Recommended</option>
                    </select>
                  {errors.recommendation && <span className="text-danger">{errors.recommendation.message}</span>}
                </div>
                <div className="form-group col-md-12">
                    <label >Brief reason for your recommendation <span className="text-danger">*</span></label>
                <textarea {...register('remark', { required: 'Field cannot be empty' })} onChange={handleChange} className="form-control" data-gramm="false" wt-ignore-input="true"></textarea></div>

                {errors.remark && <span className="text-danger">{errors.remark.message}</span>}
                <div className="form-group col-md-12">
                    <input type="checkbox" {...register('agree', { required: 'Field must be checked' })} onChange={handleChange}/>
                <label> I certify that the above information on this application is true and correct to the best of my knowledge.</label></div>
            </div>
            </div>
        </div>
  )
}

export default MentalEvaluation
